module.exports = __webpack_public_path__ + "img/appuntamenti.cc15cafd.svg";